export const PATHS = {
  BASE_PATH: 'https://hn.algolia.com/api/v1',
  SEARCH_PATH: '/search',
  SEARCH_PARAM: 'query=',
  PAGE_HITS: 'hitsPerPage=',
  PAGE_PARAM: 'page=',
};

export const HITS = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
  {
    value: 40,
    label: 40,
  },
  {
    value: 50,
    label: 50,
  },
];

export const PAGES = {
  PREV: 'prev',
  NEXT: 'next',
};
